import type React from "react";
import { ReactComponent as Svg } from "./assets/icon-star.svg";
import * as styles from "./Icon.module.scss";

type StarProps = React.SVGProps<SVGSVGElement>;

export const Star = ({ className, ...props }: StarProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
